module.exports = __webpack_public_path__ + "img/robot.0950d67b.svg";